import { _ as t } from "../internals/export.js";
import { g as r } from "../internals/get-built-in.js";
import { a as e } from "../internals/an-object.js";
import { f as n } from "../internals/freezing.js";
t({
  target: "Reflect",
  stat: !0,
  sham: !n
}, {
  preventExtensions: function preventExtensions(t) {
    e(t);
    try {
      var n = r("Object", "preventExtensions");
      return n && n(t), !0;
    } catch (t) {
      return !1;
    }
  }
});